@if (messages?.length > 0) {
@for (msg of messages; track msg) {
<div class="server-message" [ngClass]="'server-message--' + msg.criticity">
  <div class="server-message-heading">
    @if (msg.icon) {
    <em class="fal fa-fw" [ngClass]="msg.icon"></em>
    }
    <span>{{ msg.subject }}</span>
  </div>
  <div class="server-message-body">
    <span [innerHTML]="msg.body"></span>
    @if (msg.dateFrom) {
    <div class="server-message-date">Mise à jour : {{ msg.dateFrom }}</div>
    }
  </div>
</div>
}
}
